module.exports = __webpack_public_path__ + "media/mypage/images/special/experience-df9b574b9290f13e977fcf49f8c6b7ce.jpg";